import NotificationService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { STORAGE_KEYS } from "../hooks/useLocalStorage";
import Position from "../models/Position";
import WorkLog from "../models/WorkLog";
import WorkLogReport from "../models/WorkLogReport";
import { Routes } from "../types/Routes";
import { MAX_HOURS_ADJUST } from "./WorklogsUtils";

export default class WorklogReportUtils {
  public static getUrlToWorklog = (instance: WorkLogReport, date?: Date | null, day?: number): string => {
    let urlToWorklog = `${Routes.WORKLOG}?user=${instance.coreUserExternalId}&assignation=${instance.assignationExternalId}`;

    if (date) {
      if (day) {
        urlToWorklog += `&year=${date.getFullYear()}&month=${date.getMonth() + 1}&day=${day}`;
      } else {
        urlToWorklog += `&year=${date.getFullYear()}&month=${date.getMonth() + 1}`;
      }
    }

    localStorage.removeItem(STORAGE_KEYS.STORED_ASSIGNATION);
    return urlToWorklog;
  };

  public static bonusHoursIsValid = async (workLogCreated: WorkLog, position?: Position) => {
    //If position.bonus exist and is different from 0% then shouldn't be bonus hours in worklogs.
    if (!!position && position.bonus != null && position.bonus == 0) {
      return workLogCreated.bonusHours == 0;
    }
    let adjustmentHours: number = workLogCreated.adjustmentHours ? workLogCreated.adjustmentHours : 0;
    if (workLogCreated.bonusHours < 0 || workLogCreated.bonusHours > +workLogCreated.hours + +adjustmentHours) {
      workLogCreated.bonusHours < 0 && NotificationService.error(`Bonus hours can not be less than 0`);

      workLogCreated.bonusHours > +workLogCreated.hours + +adjustmentHours &&
        NotificationService.error(`Bonus hours can not be greater than ${+workLogCreated.hours + +adjustmentHours}`);

      return false;
    }
    return true;
  };

  public static negativeAdjustmentHoursIsValid = (workLog: WorkLog): boolean => {
    const value = workLog.adjustmentHours >= workLog.hours * -1;
    return value;
  };

  public static adjustmentHoursQuantityIsValid = (workLog: WorkLog): boolean => {
    return workLog.adjustmentHours <= MAX_HOURS_ADJUST; //TODO: add constant file
  };


  public static adjustmentHoursIsValid = async (workLogCreated: WorkLog, position?: Position) => {
    const maximumHours = position ? position.externalHours + MAX_HOURS_ADJUST : MAX_HOURS_ADJUST;
    const validAdjustment = this.negativeAdjustmentHoursIsValid(workLogCreated);
    const validAdjustmentHours = this.adjustmentHoursQuantityIsValid(workLogCreated);
    const validMaximumHours = workLogCreated.hours <= maximumHours + workLogCreated.adjustmentHours * -1;

    !validAdjustment && NotificationService.error(`Adjustment hours can not be less than ${workLogCreated.hours * -1}`);

    !validAdjustmentHours && NotificationService.error(`Adjustment hours can not be greater than ${MAX_HOURS_ADJUST}`);

    !validMaximumHours && NotificationService.error(`Maximum hours per day for this position can not exceed ${maximumHours}`);

    return validAdjustmentHours && validAdjustment && validMaximumHours;
  };
}
